import React from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import PropTypes from 'prop-types';

import { DetailInvoice } from 'pages/Settings/Tabs/Invoice';

const propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
  className: PropTypes.string,
};

const DialogDetailInvoice = (props) => {
  const { isOpen, toggle, className } = props;

  return (
    <Modal isOpen={isOpen} toggle={toggle} className={className} style={{ maxWidth: '100%' }}>
      <ModalHeader toggle={toggle}>Detail Invoice</ModalHeader>
      <ModalBody>
        <DetailInvoice backable={false} />
      </ModalBody>
    </Modal>
  );
};

DialogDetailInvoice.propTypes = propTypes;
export default React.memo(DialogDetailInvoice);
